// Ancient Japan Trainers Data - Group Four (Characters 19-24)

// Jiraiya's workout programs
const jirayaPrograms = [
    {
        id: 'toad-sage-training',
        name: 'Toad Sage Training',
        description: 'Amphibious conditioning that builds explosive jumping power',
        pattern: '~gvqyn',
        reps: 7,
        sets: 12,
        focus: 'Amphibious Power'
    },
    {
        id: 'summoning-strength-workout',
        name: 'Summoning Strength Workout',
        description: 'Mystical conditioning for calling forth supernatural allies',
        pattern: 'gv~qny',
        reps: 21,
        sets: 4,
        focus: 'Summoning Mastery'
    },
    {
        id: 'mountain-hermit-conditioning',
        name: 'Mountain Hermit Conditioning',
        description: 'Solitary training in harmony with nature and toad spirits',
        pattern: 'vqn~yg',
        reps: 14,
        sets: 7,
        focus: 'Hermit Discipline'
    },
    {
        id: 'legendary-ninja-protocol',
        name: 'Legendary Ninja Protocol',
        description: 'Mythical training methods passed down through folklore',
        pattern: 'qny~gv',
        reps: 28,
        sets: 3,
        focus: 'Mythical Techniques'
    },
    {
        id: 'toad-oil-endurance-training',
        name: 'Toad Oil Endurance Training',
        description: 'Slippery conditioning that makes you impossible to grapple',
        pattern: 'ny~vgq',
        reps: 16,
        sets: 5,
        focus: 'Slippery Defense'
    },
    {
        id: 'gallant-jiraiya-mastery',
        name: 'Gallant Jiraiya Mastery',
        description: 'Complete training of the legendary toad-riding ninja hero',
        pattern: '~gvqyn!',
        reps: 35,
        sets: 3,
        focus: 'Legendary Heroism'
    }
];

// Yamabushi Mountain Ascetic (Alternative)'s workout programs
const yamabushiAltPrograms = [
    {
        id: 'peak-conquest-training',
        name: 'Peak Conquest Training',
        description: 'Vertical conditioning for ascending the highest mountain peaks',
        pattern: 'lcsrbo',
        reps: 18,
        sets: 6,
        focus: 'Vertical Mastery'
    },
    {
        id: 'spirit-mountain-conditioning',
        name: 'Spirit Mountain Conditioning',
        description: 'Mystical training that connects with mountain kami spirits',
        pattern: 'csl@rb',
        reps: 11,
        sets: 9,
        focus: 'Mountain Spirits'
    },
    {
        id: 'weather-master-workout',
        name: 'Weather Master Workout',
        description: 'Training in all seasons and extreme weather conditions',
        pattern: 'srbocl',
        reps: 22,
        sets: 4,
        focus: 'Weather Mastery'
    },
    {
        id: 'avalanche-endurance-protocol',
        name: 'Avalanche Endurance Protocol',
        description: 'Survival conditioning for the most dangerous mountain conditions',
        pattern: 'rbocls',
        reps: 33,
        sets: 2,
        focus: 'Avalanche Survival'
    },
    {
        id: 'shugendo-power-training',
        name: 'Shugendo Power Training',
        description: 'Religious practice combined with extreme physical conditioning',
        pattern: 'oclsrb',
        reps: 15,
        sets: 7,
        focus: 'Religious Power'
    },
    {
        id: 'mountain-god-mastery',
        name: 'Mountain God Mastery',
        description: 'Ultimate training to become one with the mountain itself',
        pattern: 'lcsrbo!',
        reps: 27,
        sets: 3,
        focus: 'Mountain Godhood'
    }
];

// Minamoto no Yoritomo's workout programs
const minamotoYoritomoPrograms = [
    {
        id: 'first-shogun-training',
        name: 'First Shogun Training',
        description: 'Foundational military government conditioning and leadership',
        pattern: '$>&x[=',
        reps: 12,
        sets: 8,
        focus: 'Military Government'
    },
    {
        id: 'kamakura-authority-workout',
        name: 'Kamakura Authority Workout',
        description: 'Administrative strength for ruling Japan\'s first military capital',
        pattern: '>&$x=[',
        reps: 20,
        sets: 4,
        focus: 'Administrative Power'
    },
    {
        id: 'genpei-victory-conditioning',
        name: 'Genpei Victory Conditioning',
        description: 'War-winning training from the decisive Genpei conflict',
        pattern: 'x=[$>&',
        reps: 17,
        sets: 5,
        focus: 'Decisive Victory'
    },
    {
        id: 'brother-rivalry-protocol',
        name: 'Brother Rivalry Protocol',
        description: 'Competitive training forged through family conflict and ambition',
        pattern: '=[$>x&',
        reps: 24,
        sets: 3,
        focus: 'Competitive Excellence'
    },
    {
        id: 'samurai-hierarchy-training',
        name: 'Samurai Hierarchy Training',
        description: 'Systematic conditioning for organizing warrior society',
        pattern: '[$>&x=',
        reps: 14,
        sets: 6,
        focus: 'Social Organization'
    },
    {
        id: 'bakufu-founder-mastery',
        name: 'Bakufu Founder Mastery',
        description: 'Complete training for establishing lasting military rule',
        pattern: '$>&x[=!',
        reps: 25,
        sets: 4,
        focus: 'Institutional Founding'
    }
];

// Honda Tadakatsu's workout programs
const hondaTadakatsuPrograms = [
    {
        id: 'never-wounded-training',
        name: 'Never Wounded Training',
        description: 'Legendary conditioning that creates an unbreakable warrior',
        pattern: '*&)(-:',
        reps: 57,
        sets: 1,
        focus: 'Indestructible Body'
    },
    {
        id: 'antler-helmet-conditioning',
        name: 'Antler Helmet Conditioning',
        description: 'Heavy armor training with distinctive battle equipment',
        pattern: '&*)(-:',
        reps: 8,
        sets: 10,
        focus: 'Heavy Armor Mastery'
    },
    {
        id: 'tokugawa-guardian-workout',
        name: 'Tokugawa Guardian Workout',
        description: 'Elite protection training for Japan\'s most important leader',
        pattern: ')(-:*&',
        reps: 16,
        sets: 6,
        focus: 'Elite Protection'
    },
    {
        id: 'undefeated-warrior-protocol',
        name: 'Undefeated Warrior Protocol',
        description: 'Training methods that ensure victory in every engagement',
        pattern: '(-:&*)',
        reps: 23,
        sets: 4,
        focus: 'Perfect Victory'
    },
    {
        id: 'legendary-endurance-training',
        name: 'Legendary Endurance Training',
        description: 'Superhuman conditioning for fighting through any hardship',
        pattern: ':*&)(-',
        reps: 32,
        sets: 3,
        focus: 'Superhuman Endurance'
    },
    {
        id: 'immortal-warrior-mastery',
        name: 'Immortal Warrior Mastery',
        description: 'The complete training of Japan\'s most indestructible samurai',
        pattern: '*&)(-:!',
        reps: 42,
        sets: 2,
        focus: 'Warrior Immortality'
    }
];

// Sarutobi Sasuke's workout programs
const sarutobiSasukePrograms = [
    {
        id: 'monkey-agility-training',
        name: 'Monkey Agility Training',
        description: 'Primate-inspired movement for incredible jumping and climbing',
        pattern: '^_@dwa',
        reps: 19,
        sets: 7,
        focus: 'Simian Agility'
    },
    {
        id: 'tree-hopping-conditioning',
        name: 'Tree Hopping Conditioning',
        description: 'Forest parkour training for moving through canopy at speed',
        pattern: '_^@wad',
        reps: 26,
        sets: 4,
        focus: 'Canopy Navigation'
    },
    {
        id: 'youth-ninja-workout',
        name: 'Youth Ninja Workout',
        description: 'Energetic training that channels youthful enthusiasm into skill',
        pattern: '@dw^a_',
        reps: 13,
        sets: 8,
        focus: 'Youthful Energy'
    },
    {
        id: 'sanada-ten-braves-protocol',
        name: 'Sanada Ten Braves Protocol',
        description: 'Elite team training with legendary ninja companions',
        pattern: 'dwa_^@',
        reps: 10,
        sets: 10,
        focus: 'Team Excellence'
    },
    {
        id: 'acrobatic-ninja-training',
        name: 'Acrobatic Ninja Training',
        description: 'Spectacular movement training for impossible physical feats',
        pattern: 'wa_@d^',
        reps: 29,
        sets: 3,
        focus: 'Spectacular Acrobatics'
    },
    {
        id: 'legendary-sasuke-mastery',
        name: 'Legendary Sasuke Mastery',
        description: 'Complete training of the most agile ninja in Japanese folklore',
        pattern: '^_@dwa!',
        reps: 35,
        sets: 3,
        focus: 'Legendary Agility'
    }
];

// Ikebana Master's workout programs
const ikebanaPrograms = [
    {
        id: 'flower-arrangement-conditioning',
        name: 'Flower Arrangement Conditioning',
        description: 'Graceful strength training inspired by natural flower forms',
        pattern: 'wadfu^',
        reps: 3,
        sets: 15,
        focus: 'Natural Grace'
    },
    {
        id: 'seasonal-harmony-workout',
        name: 'Seasonal Harmony Workout',
        description: 'Training that flows with the changing seasons and natural cycles',
        pattern: 'adf^wu',
        reps: 4,
        sets: 12,
        focus: 'Seasonal Flow'
    },
    {
        id: 'artistic-precision-training',
        name: 'Artistic Precision Training',
        description: 'Meticulous conditioning for perfect aesthetic expression',
        pattern: 'df^wua',
        reps: 6,
        sets: 9,
        focus: 'Artistic Precision'
    },
    {
        id: 'natural-balance-protocol',
        name: 'Natural Balance Protocol',
        description: 'Training that achieves perfect harmony with natural law',
        pattern: '^wuadf',
        reps: 8,
        sets: 7,
        focus: 'Natural Harmony'
    },
    {
        id: 'living-art-conditioning',
        name: 'Living Art Conditioning',
        description: 'Conditioning that transforms the body into a work of living art',
        pattern: 'wuadf^',
        reps: 12,
        sets: 5,
        focus: 'Living Artistry'
    },
    {
        id: 'master-arranger-excellence',
        name: 'Master Arranger Excellence',
        description: 'Complete training for achieving perfect aesthetic expression',
        pattern: 'wadfu^!',
        reps: 15,
        sets: 4,
        focus: 'Aesthetic Mastery'
    }
];

// Main Ancient Japan trainers data object - Group Four
const japanFourTrainersData = {
    'jiraiya': {
        id: 'jiraiya',
        name: 'Jiraiya',
        specialization: 'Toad Magic & Legendary Ninja Arts',
        image: '/assets/images/jiraiya.jpg',
        experience: '200+ years',
        category: 'ancient-japan',
        color: '#228B22',
        secondaryColor: '#FFFF00',
        intro: `The legendary ninja who rides giant toads and commands mystical amphibian magic. Jiraiya's training combines explosive jumping power with slippery defensive techniques that make students impossible to pin down. His methods teach that true ninja power comes from harmony with nature's most adaptable creatures.`,
        programs: jirayaPrograms
    },
    'yamabushi-mountain-ascetic-alt': {
        id: 'yamabushi-mountain-ascetic-alt',
        name: 'Mountain Peak Yamabushi',
        specialization: 'Peak Conquest & Weather Mastery',
        image: '/assets/images/yamabushi-alt.jpg',
        experience: '45+ years',
        category: 'ancient-japan',
        color: '#696969',
        secondaryColor: '#F0F8FF',
        intro: `An advanced mountain ascetic who has conquered the highest peaks and mastered all weather conditions. His Shugendo training combines religious devotion with extreme physical conditioning, teaching students to find spiritual power through overcoming the mountain's greatest challenges. True strength comes from becoming one with the mountain itself.`,
        programs: yamabushiAltPrograms
    },
    'minamoto-no-yoritomo': {
        id: 'minamoto-no-yoritomo',
        name: 'Minamoto no Yoritomo',
        specialization: 'Military Government & Institutional Leadership',
        image: '/assets/images/minamoto-yoritomo.jpg',
        experience: '52+ years',
        category: 'ancient-japan',
        color: '#8B0000',
        secondaryColor: '#FFD700',
        intro: `The first shogun of Japan who established the Kamakura bakufu and created the foundation of samurai rule. His training builds administrative strength alongside military prowess, teaching students how to create lasting institutions. True leadership creates systems that outlast any individual leader.`,
        programs: minamotoYoritomoPrograms
    },
    'honda-tadakatsu': {
        id: 'honda-tadakatsu',
        name: 'Honda Tadakatsu',
        specialization: 'Indestructible Combat & Perfect Defense',
        image: '/assets/images/honda-tadakatsu.jpg',
        experience: '55+ years',
        category: 'ancient-japan',
        color: '#000000',
        secondaryColor: '#8B4513',
        intro: `The legendary samurai who survived 57 battles without receiving a single wound. His antler-horned helmet and unbreakable defense made him a living symbol of invincibility. His training creates warriors whose defense is so perfect that defeat becomes impossible. True mastery means never needing to heal because you never get hurt.`,
        programs: hondaTadakatsuPrograms
    },
    'sarutobi-sasuke': {
        id: 'sarutobi-sasuke',
        name: 'Sarutobi Sasuke',
        specialization: 'Acrobatic Ninjutsu & Youth Energy',
        image: '/assets/images/sarutobi-sasuke.jpg',
        experience: '25+ years',
        category: 'ancient-japan',
        color: '#8B4513',
        secondaryColor: '#32CD32',
        intro: `The youngest and most agile of the legendary Sanada Ten Braves, famous for his monkey-like jumping ability and tree-hopping skills. His training channels youthful enthusiasm into spectacular acrobatic feats that defy gravity. Students learn that age is just a number when you train with boundless energy and joy.`,
        programs: sarutobiSasukePrograms
    },
    'ikebana-master': {
        id: 'ikebana-master',
        name: 'Ikebana Master',
        specialization: 'Natural Harmony & Aesthetic Precision',
        image: '/assets/images/ikebana-master.jpg',
        experience: '30+ years',
        category: 'ancient-japan',
        color: '#FF69B4',
        secondaryColor: '#98FB98',
        intro: `Master of the Way of Flowers, achieving perfect aesthetic expression through disciplined arrangement of natural forms. Her training develops graceful strength and artistic precision, teaching students to find beauty in movement and power in gentleness. True mastery transforms every gesture into living art.`,
        programs: ikebanaPrograms
    }
};

// Export the data
export default japanFourTrainersData;